export const sortLeagues = (x, y) => x.defaultOrder - y.defaultOrder;
//# sourceMappingURL=sortLeagues.js.map